import { getFromApiFunction } from "../apiFunctions";

const getVillages = async (params: URLSearchParams = new URLSearchParams()) => {
  const endPoint = "/villages/";
  return getFromApiFunction(endPoint, params);
};

export { getVillages };
